import { useNavigate } from 'react-router-dom';
import { getUserInfo } from 'utils/common';

/**
 * 自定义 Hook：封装首页导航
 * @returns {Function} navFirstPage - 导航到首页
 */
const useNavFirstPage = () => {
  const navigate = useNavigate();
  const userinfo = getUserInfo();
  const navFirstPage = () => {
    if (!userinfo) return;
    if (userinfo?.role == 1000) {
      navigate('/panel/my/enterprise/information/index');
    } else {
      navigate('/panel/dashboard/index');
    }
  };

  return { navFirstPage };
};

export default useNavFirstPage;
